import { Grid } from '@mui/material';
import {
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  required,
  SelectInput,
  FileInput,
  FileField,
} from 'react-admin';
import { OfferDocumentTypeDto } from 'src/dtos';
import { FileInputHelperText } from 'src/lib';
import { validateOfferSubscriptionAgreement } from 'src/validators';

import { offerDocumentsType } from '../../constants/choices/offer.documents.choices';

import { SubscriptionAgreementShowFieldsButton } from './SubscriptionAgreementShowFieldsButton';

interface SimpleCreateEditFormProps {
  isEditMode?: boolean;
}

export const SimpleCreateEditForm = ({ isEditMode = false }: SimpleCreateEditFormProps) => {
  const validateOfferDocumentForm = async (values: any) => {
    const errors: Record<string, string> = {};

    if (!values.offerId) {
      errors.offerId = 'Required';
    }

    if (!values.type) {
      errors.type = 'Required';
    }

    if (!values._files) {
      errors._files = 'Required';

      return errors;
    }

    const file = Array.isArray(values._files) ? values._files[0]?.rawFile : values._files?.rawFile;

    // NOTE: for existing documents the admin may update the offer type to subscriptiona agreement while the file
    // has already been uploaded and not changed, hence the file is undefined failing the validation.
    if (values.type === OfferDocumentTypeDto.SUBSCRIPTION_AGREEMENT && !file) {
      errors._files = '"Subscription Agreement" document reupload is required';

      return errors;
    }
    const { messages } = await validateOfferSubscriptionAgreement({
      type: values.type,
      file,
    });

    if (messages.length > 0) {
      errors._files = messages.join(', ');
    }

    return errors;
  };

  return (
    <SimpleForm validate={validateOfferDocumentForm}>
      <Grid container direction='row' justifyContent='space-between' spacing={2}>
        <Grid item xs={12}>
          <h2>{isEditMode ? 'Edit' : 'Create'} offer document</h2>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ReferenceInput source='offerId' reference='offers' sort={{ field: 'name', order: 'ASC' }}>
            <AutocompleteInput
              label='Offer'
              optionText='name'
              validate={[required()]}
              fullWidth
              filterToQuery={searchText => ({ name: searchText })}
              disabled={isEditMode}
            />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput source='type' validate={[required()]} choices={offerDocumentsType} fullWidth />
        </Grid>
        <SubscriptionAgreementShowFieldsButton />
        <Grid item xs={12}>
          <FileInput
            source='_files'
            label='Related files'
            validate={required()}
            accept='application/pdf'
            helperText={false}
            sx={{ '& .MuiFormHelperText-root': { display: 'none' } }}>
            <FileField
              source='src'
              title='title'
              target='_blank'
              sx={{ '& img': { maxWidth: '4rem', maxHeight: '4rem', objectFit: 'contain', margin: '0.25rem' } }}
            />
          </FileInput>
          <FileInputHelperText />
        </Grid>
      </Grid>
    </SimpleForm>
  );
};

export default SimpleCreateEditForm;
